
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { 
  Users, 
  BarChart, 
  Settings, 
  UserCheck,
  DollarSign,
  CreditCard,
  LayoutDashboard,
  Building,
  MessageSquare,
  BookOpen,
  UserCog
} from 'lucide-react';

const AdminNav: React.FC = () => {
  const location = useLocation();
  
  // Function to determine if a link is active
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      <Link to="/admin/dashboard">
        <Button 
          variant={isActive("/admin/dashboard") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <LayoutDashboard className="h-4 w-4" />
          <span>Dashboard</span>
        </Button>
      </Link>
      
      <Link to="/admin/reports">
        <Button 
          variant={isActive("/admin/reports") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <BarChart className="h-4 w-4" />
          <span>Reports</span>
        </Button>
      </Link>
      
      <Link to="/admin/crm">
        <Button 
          variant={isActive("/admin/crm") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <MessageSquare className="h-4 w-4" />
          <span>CRM</span>
        </Button>
      </Link>
      
      <Link to="/admin/referrer-payments">
        <Button 
          variant={isActive("/admin/referrer-payments") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <DollarSign className="h-4 w-4" />
          <span>Referrer Payments</span>
        </Button>
      </Link>
      
      <Link to="/admin/payments">
        <Button 
          variant={isActive("/admin/payments") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <CreditCard className="h-4 w-4" />
          <span>Payments</span>
        </Button>
      </Link>
      
      <Link to="/admin/referral-users">
        <Button 
          variant={isActive("/admin/referral-users") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <UserCheck className="h-4 w-4" />
          <span>Referral Users</span>
        </Button>
      </Link>
      
      <Link to="/admin/auto-users">
        <Button 
          variant={isActive("/admin/auto-users") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <UserCog className="h-4 w-4" />
          <span>Auto Users</span>
        </Button>
      </Link>
      
      <Link to="/admin/user-management">
        <Button 
          variant={isActive("/admin/user-management") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <Users className="h-4 w-4" />
          <span>User-Role Manager</span>
        </Button>
      </Link>
      
      <Link to="/admin/business-setup">
        <Button 
          variant={isActive("/admin/business-setup") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <Building className="h-4 w-4" />
          <span>Business</span>
        </Button>
      </Link>
      
      <Link to="/admin/support">
        <Button 
          variant={isActive("/admin/support") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <MessageSquare className="h-4 w-4" />
          <span>Support</span>
        </Button>
      </Link>
      
      <Link to="/admin/knowledge-base">
        <Button 
          variant={isActive("/admin/knowledge-base") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <BookOpen className="h-4 w-4" />
          <span>Guides</span>
        </Button>
      </Link>
      
      <Link to="/admin/settings">
        <Button 
          variant={isActive("/admin/settings") ? "default" : "outline"} 
          size="sm" 
          className="flex items-center gap-1"
        >
          <Settings className="h-4 w-4" />
          <span>Settings</span>
        </Button>
      </Link>
    </div>
  );
};

export default AdminNav;
